import { useContext } from "react"

import { AnalyticsContext } from "../providers/AnalyticsProvider/AnalyticsContextProvider"

export const useAnalyticsContext = () => {
  const ctx = useContext(AnalyticsContext)
  if (!ctx) {
    throw new Error(
      "useAnalyticsContext must be used within an AnalyticsProvider",
    )
  }
  return ctx
}
